var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout" },
    [
      _vm.getOverrideDayName(_vm.serviceAreaItem)
        ? _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-100 delivery-window-override-day-container",
            },
            [
              _c("div", { staticClass: "override-day-content" }, [
                _c("div", { staticClass: "override-day-title" }, [
                  _vm._v(_vm._s(_vm.getOverrideDayName(_vm.serviceAreaItem))),
                ]),
                _c("div", { staticClass: "override-day-description" }, [
                  _vm._v(
                    "\n                Special capacity settings applied for " +
                      _vm._s(_vm.formatDate(_vm.selectedDate)) +
                      "\n            "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "override-day-date" }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.selectedDate))),
              ]),
            ]
          )
        : _vm._e(),
      _vm._l(
        _vm.getGroupedDeliveryWindows(_vm.serviceAreaItem),
        function (capacityItems, itemRange) {
          return _c(
            "div",
            {
              key: itemRange,
              staticClass:
                "md-layout-item md-size-100 delivery-window-container",
            },
            [
              itemRange === "12:00 AM - 11:59 PM"
                ? [
                    _vm._m(0, true),
                    _c(
                      "div",
                      { staticClass: "capacity-container" },
                      _vm._l(capacityItems, function (capacityItem, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "capacity-tile" },
                          [
                            _c(
                              "stats-card",
                              { attrs: { "show-actions": false } },
                              [
                                _c("template", { slot: "header" }, [
                                  _c("p", { staticClass: "category" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getCapacityItemTypeLabel(
                                            capacityItem.type
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                  _c("h3", { staticClass: "title" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getCurrentCapacityWithSymbol(
                                            capacityItem
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                : [
                    _c("div", { staticClass: "delivery-window-header" }, [
                      _c("h6", { staticClass: "delivery-window-title" }, [
                        _vm._v(_vm._s(itemRange)),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "capacity-container" },
                      _vm._l(capacityItems, function (capacityItem, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "capacity-item-container",
                          },
                          [
                            _c("div", { staticClass: "capacity-item-title" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getCapacityItemTypeLabel(
                                      capacityItem.type
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "capacity-item-bar-container" },
                              [
                                _c("div", {
                                  staticClass:
                                    "capacity-item-bar-container-fill",
                                  style: {
                                    width: _vm.hasMaxCapacity(capacityItem)
                                      ? _vm.getPercentage(capacityItem) + "%"
                                      : "100%",
                                    backgroundColor:
                                      _vm.getCapacityBarColor(capacityItem),
                                  },
                                }),
                              ]
                            ),
                            _c("div", { staticClass: "capacity-item-info" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getCapacityInfoLabel(capacityItem)
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
            ],
            2
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "delivery-window-header" }, [
      _c("h6", { staticClass: "delivery-window-title" }, [
        _vm._v("No time window"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }